var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBarIndicator = function SvgBarIndicator(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 187,
    viewBox: "0 0 258 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_191_99369)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 56,
    width: 186,
    height: 80,
    rx: 15,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.38 87C57.2 87 57.06 86.9533 56.96 86.86C56.8667 86.76 56.82 86.62 56.82 86.44V80.51C56.82 80.33 56.8667 80.1933 56.96 80.1C57.06 80 57.2 79.95 57.38 79.95H59.76C60.2467 79.95 60.66 80.0233 61 80.17C61.3467 80.3167 61.61 80.5267 61.79 80.8C61.9767 81.0733 62.07 81.4033 62.07 81.79C62.07 82.2167 61.9433 82.5767 61.69 82.87C61.4367 83.1633 61.0933 83.36 60.66 83.46V83.31C61.1533 83.3767 61.54 83.5633 61.82 83.87C62.1 84.17 62.24 84.5633 62.24 85.05C62.24 85.6767 62.0333 86.16 61.62 86.5C61.2067 86.8333 60.6267 87 59.88 87H57.38ZM57.82 86.2H59.76C60.26 86.2 60.63 86.1033 60.87 85.91C61.11 85.71 61.23 85.41 61.23 85.01C61.23 84.61 61.11 84.3133 60.87 84.12C60.63 83.9267 60.26 83.83 59.76 83.83H57.82V86.2ZM57.82 83.03H59.6C60.08 83.03 60.4433 82.9333 60.69 82.74C60.9367 82.5467 61.06 82.2633 61.06 81.89C61.06 81.5167 60.9367 81.2333 60.69 81.04C60.4433 80.8467 60.08 80.75 59.6 80.75H57.82V83.03ZM65.2114 87.09C64.8714 87.09 64.5647 87.0233 64.2914 86.89C64.0247 86.7567 63.8147 86.5767 63.6614 86.35C63.5081 86.1233 63.4314 85.8667 63.4314 85.58C63.4314 85.22 63.5214 84.9367 63.7014 84.73C63.8881 84.5167 64.1914 84.3667 64.6114 84.28C65.0381 84.1867 65.6114 84.14 66.3314 84.14H66.8014V84.76H66.3414C65.8614 84.76 65.4814 84.7833 65.2014 84.83C64.9214 84.8767 64.7214 84.9567 64.6014 85.07C64.4881 85.1767 64.4314 85.3267 64.4314 85.52C64.4314 85.7733 64.5181 85.98 64.6914 86.14C64.8647 86.2933 65.1047 86.37 65.4114 86.37C65.6581 86.37 65.8747 86.3133 66.0614 86.2C66.2481 86.08 66.3947 85.92 66.5014 85.72C66.6147 85.52 66.6714 85.29 66.6714 85.03V83.88C66.6714 83.5 66.5914 83.2267 66.4314 83.06C66.2714 82.8933 66.0081 82.81 65.6414 82.81C65.4281 82.81 65.2047 82.8367 64.9714 82.89C64.7447 82.9433 64.5081 83.0333 64.2614 83.16C64.1481 83.2133 64.0514 83.23 63.9714 83.21C63.8914 83.19 63.8281 83.1467 63.7814 83.08C63.7347 83.0067 63.7081 82.93 63.7014 82.85C63.7014 82.7633 63.7214 82.68 63.7614 82.6C63.8081 82.52 63.8847 82.46 63.9914 82.42C64.2847 82.28 64.5747 82.18 64.8614 82.12C65.1481 82.06 65.4181 82.03 65.6714 82.03C66.1181 82.03 66.4847 82.1 66.7714 82.24C67.0647 82.38 67.2814 82.5933 67.4214 82.88C67.5614 83.1667 67.6314 83.5367 67.6314 83.99V86.56C67.6314 86.72 67.5914 86.8467 67.5114 86.94C67.4314 87.0267 67.3147 87.07 67.1614 87.07C67.0147 87.07 66.8981 87.0267 66.8114 86.94C66.7247 86.8467 66.6814 86.72 66.6814 86.56V85.91H66.7714C66.7181 86.1567 66.6181 86.37 66.4714 86.55C66.3314 86.7233 66.1547 86.8567 65.9414 86.95C65.7281 87.0433 65.4847 87.09 65.2114 87.09ZM71.2275 87.09C70.8275 87.09 70.4908 87.02 70.2175 86.88C69.9442 86.74 69.7408 86.5333 69.6075 86.26C69.4742 85.9867 69.4075 85.6533 69.4075 85.26V82.9H68.8075C68.6742 82.9 68.5708 82.8667 68.4975 82.8C68.4242 82.7267 68.3875 82.63 68.3875 82.51C68.3875 82.3833 68.4242 82.2867 68.4975 82.22C68.5708 82.1533 68.6742 82.12 68.8075 82.12H69.4075V81.09C69.4075 80.9233 69.4508 80.7967 69.5375 80.71C69.6308 80.6233 69.7575 80.58 69.9175 80.58C70.0775 80.58 70.2008 80.6233 70.2875 80.71C70.3742 80.7967 70.4175 80.9233 70.4175 81.09V82.12H71.5875C71.7208 82.12 71.8242 82.1533 71.8975 82.22C71.9708 82.2867 72.0075 82.3833 72.0075 82.51C72.0075 82.63 71.9708 82.7267 71.8975 82.8C71.8242 82.8667 71.7208 82.9 71.5875 82.9H70.4175V85.18C70.4175 85.5333 70.4908 85.8 70.6375 85.98C70.7908 86.16 71.0375 86.25 71.3775 86.25C71.4975 86.25 71.6008 86.24 71.6875 86.22C71.7808 86.1933 71.8575 86.1767 71.9175 86.17C71.9908 86.17 72.0508 86.1967 72.0975 86.25C72.1442 86.2967 72.1675 86.39 72.1675 86.53C72.1675 86.63 72.1475 86.7233 72.1075 86.81C72.0742 86.8967 72.0108 86.9533 71.9175 86.98C71.8375 87.0067 71.7275 87.03 71.5875 87.05C71.4542 87.0767 71.3342 87.09 71.2275 87.09ZM74.8095 87.09C74.4095 87.09 74.0729 87.02 73.7995 86.88C73.5262 86.74 73.3229 86.5333 73.1895 86.26C73.0562 85.9867 72.9895 85.6533 72.9895 85.26V82.9H72.3895C72.2562 82.9 72.1529 82.8667 72.0795 82.8C72.0062 82.7267 71.9695 82.63 71.9695 82.51C71.9695 82.3833 72.0062 82.2867 72.0795 82.22C72.1529 82.1533 72.2562 82.12 72.3895 82.12H72.9895V81.09C72.9895 80.9233 73.0329 80.7967 73.1195 80.71C73.2129 80.6233 73.3395 80.58 73.4995 80.58C73.6595 80.58 73.7829 80.6233 73.8695 80.71C73.9562 80.7967 73.9995 80.9233 73.9995 81.09V82.12H75.1695C75.3029 82.12 75.4062 82.1533 75.4795 82.22C75.5529 82.2867 75.5895 82.3833 75.5895 82.51C75.5895 82.63 75.5529 82.7267 75.4795 82.8C75.4062 82.8667 75.3029 82.9 75.1695 82.9H73.9995V85.18C73.9995 85.5333 74.0729 85.8 74.2195 85.98C74.3729 86.16 74.6195 86.25 74.9595 86.25C75.0795 86.25 75.1829 86.24 75.2695 86.22C75.3629 86.1933 75.4395 86.1767 75.4995 86.17C75.5729 86.17 75.6329 86.1967 75.6795 86.25C75.7262 86.2967 75.7495 86.39 75.7495 86.53C75.7495 86.63 75.7295 86.7233 75.6895 86.81C75.6562 86.8967 75.5929 86.9533 75.4995 86.98C75.4195 87.0067 75.3095 87.03 75.1695 87.05C75.0362 87.0767 74.9162 87.09 74.8095 87.09ZM78.748 87.09C78.2147 87.09 77.7547 86.99 77.368 86.79C76.988 86.5833 76.6914 86.2933 76.478 85.92C76.2714 85.54 76.168 85.09 76.168 84.57C76.168 84.0633 76.2714 83.62 76.478 83.24C76.6847 82.86 76.968 82.5633 77.328 82.35C77.688 82.1367 78.098 82.03 78.558 82.03C78.898 82.03 79.2014 82.0867 79.468 82.2C79.7347 82.3067 79.9614 82.4667 80.148 82.68C80.3414 82.8867 80.4847 83.14 80.578 83.44C80.678 83.74 80.728 84.0767 80.728 84.45C80.728 84.5633 80.6947 84.65 80.628 84.71C80.5614 84.7633 80.4614 84.79 80.328 84.79H76.968V84.17H80.048L79.878 84.31C79.878 83.9767 79.828 83.6933 79.728 83.46C79.6347 83.2267 79.4914 83.05 79.298 82.93C79.1114 82.8033 78.878 82.74 78.598 82.74C78.2847 82.74 78.018 82.8133 77.798 82.96C77.5847 83.1067 77.4214 83.31 77.308 83.57C77.1947 83.83 77.138 84.1333 77.138 84.48V84.54C77.138 85.1267 77.2747 85.57 77.548 85.87C77.828 86.1633 78.2314 86.31 78.758 86.31C78.958 86.31 79.168 86.2833 79.388 86.23C79.6147 86.1767 79.828 86.0867 80.028 85.96C80.1414 85.8933 80.2414 85.8633 80.328 85.87C80.4214 85.8767 80.4947 85.9067 80.548 85.96C80.608 86.0133 80.6447 86.08 80.658 86.16C80.6714 86.24 80.658 86.3233 80.618 86.41C80.578 86.49 80.508 86.5633 80.408 86.63C80.1814 86.7833 79.918 86.9 79.618 86.98C79.318 87.0533 79.028 87.09 78.748 87.09ZM82.4641 87.07C82.2975 87.07 82.1708 87.0267 82.0841 86.94C81.9975 86.8467 81.9541 86.72 81.9541 86.56V82.56C81.9541 82.3933 81.9975 82.2667 82.0841 82.18C82.1708 82.0933 82.2908 82.05 82.4441 82.05C82.6041 82.05 82.7241 82.0933 82.8041 82.18C82.8908 82.2667 82.9341 82.3933 82.9341 82.56V83.29H82.8341C82.9408 82.89 83.1375 82.5867 83.4241 82.38C83.7108 82.1733 84.0775 82.0533 84.5241 82.02C84.6441 82.0133 84.7375 82.0433 84.8041 82.11C84.8775 82.1767 84.9175 82.28 84.9241 82.42C84.9375 82.56 84.9075 82.6733 84.8341 82.76C84.7608 82.84 84.6475 82.8867 84.4941 82.9L84.3041 82.92C83.8708 82.96 83.5408 83.0967 83.3141 83.33C83.0875 83.5633 82.9741 83.8833 82.9741 84.29V86.56C82.9741 86.72 82.9308 86.8467 82.8441 86.94C82.7641 87.0267 82.6375 87.07 82.4641 87.07ZM87.2623 88.87C87.1423 88.87 87.0423 88.8367 86.9623 88.77C86.889 88.71 86.8457 88.6267 86.8323 88.52C86.8257 88.42 86.8457 88.31 86.8923 88.19L87.5723 86.66V87.09L85.7023 82.74C85.6557 82.62 85.639 82.5067 85.6523 82.4C85.6657 82.2933 85.7157 82.21 85.8023 82.15C85.889 82.0833 86.0057 82.05 86.1523 82.05C86.279 82.05 86.379 82.08 86.4523 82.14C86.5257 82.2 86.5923 82.3033 86.6523 82.45L88.1623 86.18H87.8823L89.4123 82.45C89.4723 82.2967 89.5423 82.1933 89.6223 82.14C89.7023 82.08 89.8123 82.05 89.9523 82.05C90.0723 82.05 90.1657 82.0833 90.2323 82.15C90.3057 82.21 90.349 82.2933 90.3623 82.4C90.3823 82.5 90.3657 82.61 90.3123 82.73L87.8123 88.48C87.7457 88.6333 87.669 88.7367 87.5823 88.79C87.5023 88.8433 87.3957 88.87 87.2623 88.87Z",
    fill: "#9E9E9E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.504 89.108C179.04 89.108 178.572 89.04 178.1 88.904C177.636 88.768 177.232 88.568 176.888 88.304C176.784 88.232 176.716 88.152 176.684 88.064C176.652 87.968 176.644 87.88 176.66 87.8C176.684 87.712 176.728 87.64 176.792 87.584C176.856 87.52 176.932 87.484 177.02 87.476C177.116 87.468 177.22 87.5 177.332 87.572C177.684 87.804 178.036 87.972 178.388 88.076C178.74 88.18 179.104 88.232 179.48 88.232C179.888 88.232 180.232 88.172 180.512 88.052C180.792 87.932 181.004 87.756 181.148 87.524C181.292 87.284 181.364 86.992 181.364 86.648C181.364 86.152 181.2 85.776 180.872 85.52C180.544 85.264 180.068 85.136 179.444 85.136H178.592C178.44 85.136 178.324 85.1 178.244 85.028C178.164 84.948 178.124 84.84 178.124 84.704C178.124 84.576 178.164 84.476 178.244 84.404C178.324 84.324 178.44 84.284 178.592 84.284H179.36C179.728 84.284 180.04 84.22 180.296 84.092C180.56 83.964 180.764 83.784 180.908 83.552C181.052 83.312 181.124 83.024 181.124 82.688C181.124 82.24 180.98 81.9 180.692 81.668C180.404 81.428 179.988 81.308 179.444 81.308C179.084 81.308 178.744 81.36 178.424 81.464C178.104 81.568 177.788 81.744 177.476 81.992C177.38 82.064 177.284 82.1 177.188 82.1C177.1 82.092 177.024 82.064 176.96 82.016C176.904 81.96 176.86 81.888 176.828 81.8C176.804 81.712 176.808 81.624 176.84 81.536C176.872 81.44 176.94 81.352 177.044 81.272C177.364 81 177.74 80.792 178.172 80.648C178.604 80.504 179.048 80.432 179.504 80.432C180.048 80.432 180.512 80.52 180.896 80.696C181.288 80.864 181.588 81.112 181.796 81.44C182.004 81.76 182.108 82.148 182.108 82.604C182.108 82.948 182.04 83.264 181.904 83.552C181.776 83.832 181.592 84.072 181.352 84.272C181.12 84.472 180.836 84.616 180.5 84.704V84.572C181.084 84.668 181.536 84.908 181.856 85.292C182.184 85.668 182.348 86.144 182.348 86.72C182.348 87.208 182.232 87.632 182 87.992C181.776 88.344 181.452 88.62 181.028 88.82C180.604 89.012 180.096 89.108 179.504 89.108ZM187.083 89.108C186.419 89.108 185.851 88.948 185.379 88.628C184.915 88.3 184.563 87.828 184.323 87.212C184.083 86.596 183.963 85.852 183.963 84.98C183.963 84.244 184.039 83.596 184.191 83.036C184.343 82.476 184.567 82.004 184.863 81.62C185.159 81.228 185.519 80.932 185.943 80.732C186.367 80.532 186.847 80.432 187.383 80.432C187.751 80.432 188.127 80.504 188.511 80.648C188.903 80.792 189.247 80.996 189.543 81.26C189.631 81.324 189.683 81.404 189.699 81.5C189.723 81.588 189.723 81.676 189.699 81.764C189.675 81.844 189.631 81.912 189.567 81.968C189.511 82.024 189.439 82.056 189.351 82.064C189.263 82.064 189.171 82.028 189.075 81.956C188.803 81.724 188.523 81.56 188.235 81.464C187.947 81.36 187.655 81.308 187.359 81.308C186.839 81.308 186.395 81.436 186.027 81.692C185.667 81.948 185.391 82.336 185.199 82.856C185.015 83.368 184.923 84.012 184.923 84.788V85.904H184.815C184.863 85.448 184.995 85.056 185.211 84.728C185.435 84.392 185.719 84.136 186.063 83.96C186.407 83.784 186.795 83.696 187.227 83.696C187.723 83.696 188.163 83.808 188.547 84.032C188.931 84.256 189.231 84.572 189.447 84.98C189.663 85.38 189.771 85.84 189.771 86.36C189.771 86.888 189.659 87.36 189.435 87.776C189.211 88.192 188.895 88.52 188.487 88.76C188.079 88.992 187.611 89.108 187.083 89.108ZM187.023 88.268C187.375 88.268 187.687 88.192 187.959 88.04C188.231 87.88 188.443 87.66 188.595 87.38C188.747 87.092 188.823 86.764 188.823 86.396C188.823 86.028 188.747 85.704 188.595 85.424C188.443 85.144 188.231 84.924 187.959 84.764C187.687 84.604 187.375 84.524 187.023 84.524C186.671 84.524 186.359 84.604 186.087 84.764C185.815 84.924 185.603 85.144 185.451 85.424C185.299 85.704 185.223 86.028 185.223 86.396C185.223 86.764 185.299 87.092 185.451 87.38C185.603 87.66 185.815 87.88 186.087 88.04C186.359 88.192 186.671 88.268 187.023 88.268ZM193.991 89.012C193.935 89.116 193.867 89.184 193.787 89.216C193.707 89.256 193.627 89.264 193.547 89.24C193.467 89.224 193.399 89.184 193.343 89.12C193.287 89.064 193.251 88.992 193.235 88.904C193.227 88.816 193.251 88.72 193.307 88.616L197.939 80.552C197.995 80.448 198.063 80.38 198.143 80.348C198.223 80.308 198.303 80.3 198.383 80.324C198.463 80.34 198.531 80.38 198.587 80.444C198.643 80.508 198.675 80.584 198.683 80.672C198.699 80.76 198.679 80.852 198.623 80.948L193.991 89.012ZM193.103 85.616C192.463 85.616 191.963 85.388 191.603 84.932C191.243 84.476 191.063 83.84 191.063 83.024C191.063 82.48 191.143 82.016 191.303 81.632C191.471 81.248 191.707 80.956 192.011 80.756C192.315 80.548 192.679 80.444 193.103 80.444C193.735 80.444 194.231 80.672 194.591 81.128C194.959 81.576 195.143 82.208 195.143 83.024C195.143 83.568 195.059 84.032 194.891 84.416C194.731 84.8 194.499 85.096 194.195 85.304C193.891 85.512 193.527 85.616 193.103 85.616ZM193.103 84.908C193.351 84.908 193.563 84.836 193.739 84.692C193.923 84.548 194.063 84.336 194.159 84.056C194.255 83.776 194.303 83.432 194.303 83.024C194.303 82.4 194.195 81.932 193.979 81.62C193.763 81.308 193.471 81.152 193.103 81.152C192.855 81.152 192.639 81.224 192.455 81.368C192.279 81.504 192.143 81.712 192.047 81.992C191.951 82.264 191.903 82.608 191.903 83.024C191.903 83.648 192.007 84.12 192.215 84.44C192.431 84.752 192.727 84.908 193.103 84.908ZM198.839 89.108C198.207 89.108 197.707 88.88 197.339 88.424C196.979 87.968 196.799 87.332 196.799 86.516C196.799 85.972 196.879 85.508 197.039 85.124C197.207 84.74 197.443 84.448 197.747 84.248C198.059 84.04 198.423 83.936 198.839 83.936C199.479 83.936 199.979 84.164 200.339 84.62C200.699 85.068 200.879 85.7 200.879 86.516C200.879 87.06 200.799 87.528 200.639 87.92C200.479 88.304 200.247 88.6 199.943 88.808C199.639 89.008 199.271 89.108 198.839 89.108ZM198.839 88.4C199.095 88.4 199.311 88.332 199.487 88.196C199.663 88.052 199.799 87.84 199.895 87.56C199.991 87.28 200.039 86.932 200.039 86.516C200.039 85.892 199.931 85.424 199.715 85.112C199.507 84.8 199.215 84.644 198.839 84.644C198.591 84.644 198.375 84.716 198.191 84.86C198.015 84.996 197.879 85.204 197.783 85.484C197.695 85.756 197.651 86.1 197.651 86.516C197.651 87.148 197.755 87.62 197.963 87.932C198.179 88.244 198.471 88.4 198.839 88.4Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_191_99369)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 11,
    transform: "translate(56 104)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.1992,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.4004,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.5996,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.8008,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.1992,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.4004,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.5996,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.8008,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.199,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.4,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.6,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.801,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 119,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.199,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.4,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#1DE9B6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.6,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.801,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.199,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.4,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.6,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.801,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.199,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.4,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.6,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.801,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.199,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.4,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.6,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.801,
    y: 104,
    width: 2,
    height: 11,
    rx: 1,
    fill: "#EEEEEE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_191_99369",
    x: 0,
    y: 44,
    width: 258,
    height: 152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 24
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.05 0 0 0 0 0.0555 0 0 0 0 0.1875 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_191_99369"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_191_99369",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_191_99369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 145,
    height: 11,
    fill: "white",
    transform: "translate(56 104)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBarIndicator);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "bar-indicator.38b1fe7a9857eb828c96bf7af2c972eb.svg";